export default {
    sim_provider_accounts_title: "Cuentas de proveedores SIM",
    sim_provider_accounts_name: "Nombre de la Cuenta",
    sim_provider_accounts_sim_provider: "Proveedor de SIM",
    sim_provider_accounts_add: "Agregar cuenta de proveedor SIM",
    sim_provider_accounts_edit_title: "Editar cuenta de proveedor SIM",
    sim_provider_accounts_delete_title: "Eliminar cuenta de proveedor SIM",
    sim_provider_accounts_sim_type: "Tipo de SIM",
}